import { FILTER_SET, FILTER_RESET } from "../actionNames";

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_SET:
      const set = { ...state };
      set[action.name] = action.state;
      return set;

    case FILTER_RESET:
      const reset = {
        ...state,
      };
      reset[action.name] = undefined;
      return reset;

    default:
      return state;
  }
};

export default reducer;
